import { render, staticRenderFns } from "./MasterPassDialog.vue?vue&type=template&id=a2391c12&scoped=true"
import script from "./MasterPassDialog.vue?vue&type=script&lang=ts"
export * from "./MasterPassDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2391c12",
  null
  
)

export default component.exports